export default () => {
  $('.thor-slider .slider').slick()
  $('.hero-block').slick({
    dots: true,
    appendDots: '.hero-dots',
    prevArrow: '.hero-nav .slick-prev',
    nextArrow: '.hero-nav .slick-next',
})


const partnersSlider = $('.partners-slider')

partnersSlider.not('.slick-initialized').each(function () {
  $(this).slick({
    slidesToShow: 5,
      slidesToScroll: 1,
      autoplay: true,
      infinite: true,
      draggable: true,
      touchMove: true,
      swipeToSlide: true,
      pauseOnHover: false,
      autoplaySpeed: 3000,
      responsive: [{
          breakpoint: 768,
          settings: {
          slidesToShow: 3,
          },
        },
        {
          breakpoint: 1024,
          settings: {
          slidesToShow: 4,
          },
        },
        {
          breakpoint: 567,
          settings: {
          slidesToShow: 2,
          },
        },
      ],
    })
});


const servicesSlider = $('.services-list')

servicesSlider.not('.slick-initialized').each(function () {
  const prevArrow = $(this).siblings('.prev-arrow');
  const nextArrow = $(this).siblings('.next-arrow');

  const arrowMobile = $(this).siblings('.slider-mobile-arrows');
  const arrowPrevMobile = arrowMobile.find('.prev-arrow.mobile');
  const arrowNextMobile = arrowMobile.find('.next-arrow.mobile');

  $(this).slick({
    arrows: true,
    slidesToShow: 2,
    prevArrow: prevArrow,
    nextArrow: nextArrow,
    responsive: [
      {
        breakpoint: 1280,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          arrows: true,
          infinite: true,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          prevArrow: arrowPrevMobile,
          nextArrow: arrowNextMobile,
          slidesToScroll: 1,
        },
      },
    ],
  })
})

const relatedSlider = $('.related-slider')

relatedSlider.not('.slick-initialized').each(function () {
const prevArrow = $(this).siblings('.prev-arrow');
const nextArrow = $(this).siblings('.next-arrow');

const arrowMobile = $(this).siblings('.slider-mobile-arrows');
const arrowPrevMobile = arrowMobile.find('.prev-arrow.mobile');
const arrowNextMobile = arrowMobile.find('.next-arrow.mobile');


  $(this).slick({
    arrows: true,
    slidesToShow: 5,
    prevArrow: prevArrow,
    nextArrow: nextArrow,
    responsive: [
      {
        breakpoint: 1280,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 2,
          arrows: true,
          infinite: true,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
          prevArrow: arrowPrevMobile,
          nextArrow: arrowNextMobile,
          slidesToScroll: 1,
        },
      },
    ],
  })
});

const relatedPostSlider = $('.related-post-slider')


relatedPostSlider.not('.slick-initialized').each(function () {
const prevArrow = $(this).siblings('.prev-arrow');
const nextArrow = $(this).siblings('.next-arrow');

const arrowMobile = $(this).siblings('.slider-mobile-arrows');
const arrowPrevMobile = arrowMobile.find('.prev-arrow.mobile');
const arrowNextMobile = arrowMobile.find('.next-arrow.mobile');


$(this).slick({
    autoplay: true,
    slidesToShow: 3,
    prevArrow: prevArrow,
    nextArrow: nextArrow,
    responsive: [
      {
        breakpoint: 1280,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          arrows: true,
          infinite: true,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          prevArrow: arrowPrevMobile,
          nextArrow: arrowNextMobile,
          slidesToScroll: 1,
        },
      },
    ],
})
});


const relatedStoriesSlider = $('.related-stories-slider')

relatedStoriesSlider.not('.slick-initialized').each(function () {
  const prevArrow = $(this).siblings('.prev-arrow');
  const nextArrow = $(this).siblings('.next-arrow');

  const arrowMobile = $(this).siblings('.slider-mobile-arrows');
  const arrowPrevMobile = arrowMobile.find('.prev-arrow.mobile');
  const arrowNextMobile = arrowMobile.find('.next-arrow.mobile');


  $(this).slick({
    autoplay: true,
    slidesToShow: 4,
    prevArrow: prevArrow,
    nextArrow: nextArrow,
    responsive: [
      {
        breakpoint: 1280,
        settings: {
          slidesToShow: 3,
          arrows: true,
          infinite: true,
        },
      },
      {
        breakpoint: 768,
        settings: {
          prevArrow: arrowPrevMobile,
          nextArrow: arrowNextMobile,
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 568,
        settings: {
          prevArrow: arrowPrevMobile,
          nextArrow: arrowNextMobile,
          slidesToShow: 1,
        },
      },
    ],
  })
});




const reviewsSlider = $('.reviews-slider')

$.fn.randomize = function(selector){
  var $elems = selector ? $(this).find(selector) : $(this).children(),
      $parents = $elems.parent();

  $parents.each(function(){
      $(this).children(selector).sort(function(){
          return Math.round(Math.random()) - 0.5;
      }).detach().appendTo(this);
  });

  return this;
};


reviewsSlider.not('.slick-initialized').each(function () {
  $(this).randomize('.single-review');
  
  const prevArrow = $(this).siblings('.prev-arrow');
  const nextArrow = $(this).siblings('.next-arrow');

  const arrowMobile = $(this).siblings('.slider-mobile-arrows');
  const arrowPrevMobile = arrowMobile.find('.prev-arrow.mobile');
  const arrowNextMobile = arrowMobile.find('.next-arrow.mobile');

  $(this).slick({
    slidesToShow: 3,
    prevArrow: prevArrow,
    nextArrow: nextArrow,
    arrows: true,
    responsive: [
      {
        breakpoint: 1440,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          prevArrow: arrowPrevMobile,
          nextArrow: arrowNextMobile,
          slidesToScroll: 1,
        },
      },
    ],
  })
});

const sliderPeople = $('.slider-people')

sliderPeople.not('.slick-initialized').each(function () {
const parent = $(this).parents('.container')
const prevArrow = parent.siblings('.prev-arrow');
const nextArrow = parent.siblings('.next-arrow');

const arrowMobile = parent.siblings('.slider-mobile-arrows');
const arrowPrevMobile = arrowMobile.find('.prev-arrow.mobile');
const arrowNextMobile = arrowMobile.find('.next-arrow.mobile');

    $(this).slick({
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: true,
    slidesToShow: 3,
    prevArrow: prevArrow,
    nextArrow: nextArrow,
    responsive: [
      {
        breakpoint: 1280,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          prevArrow: arrowPrevMobile,
          nextArrow: arrowNextMobile,
          slidesToScroll: 1,
        },
      },
    ],
    })
  });
}


// WEBPACK FOOTER //
// ./scripts/layout/sliders.js